import useManagementHistory from "./management-history.hooks";
import {ActiveDotIcon, CloseIcon, InactiveDotIcon} from "../../asset";
import {Timeline} from "antd";
import {t} from "i18next";

const ManagementHistory = ({tableName, id, detail, userManagementOpen, setUserManagementOpen,}) => {
    const {
        convertTimestamp,
        managementHistoryList,
        convertToTime
    } = useManagementHistory({tableName, id});

    return (
        <>
            <aside
                className={
                    userManagementOpen
                        ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto "
                        : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
                }
            >
                <button
                    className="absolute top-[21px] right-[21px]"
                    onClick={() => setUserManagementOpen(false)}
                >
                    <img src={CloseIcon} alt=""/>
                </button>

                <h3 className="font-sans font-[600] text-[#1D1D1D] text-[20px]">
                    {t("Data Management History")}
                </h3>
                <p className="font-sans font-[400] text-[#818181] text-[12px] mb-[24px]">
                    {t("Created By")} <strong>{detail?.created_by_name}</strong>{" "}
                    {t("On")}{" "}
                    <strong>{convertTimestamp(detail?.created_at)}</strong>
                </p>

                <div>
                    <Timeline>
                        {managementHistoryList.map((item, index) => {
                            if (index === 0) {
                                return (
                                    <Timeline.Item dot={<img src={ActiveDotIcon}/>}>
                                        <div
                                            className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                                            <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>
                                                {t("Last Modified")}
                                            </h4>
                                            <h4 className="font-[500] text-[14px] text-[#424242]">
                                                {item.alias_name}
                                            </h4>
                                            <p className="font-[400] text-[14px]">{`${convertTimestamp(
                                                item.created_at
                                            )} • ${convertToTime(item.created_at)}`}</p>
                                        </div>
                                    </Timeline.Item>
                                );
                            } else {
                                return (
                                    <Timeline.Item dot={<img src={InactiveDotIcon}/>}>
                                        <div
                                            className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                                            <h4 className={"font-[500]"}>
                                                {t("Modified")}
                                            </h4>
                                            <h4 className="font-[500] text-[14px] text-[#424242]">
                                                {item.alias_name}
                                            </h4>
                                            <p className="font-[400] text-[14px]">{`${convertTimestamp(
                                                item.created_at
                                            )} • ${convertToTime(item.created_at)}`}</p>
                                        </div>
                                    </Timeline.Item>
                                );
                            }
                        })}
                    </Timeline>
                </div>
            </aside>
        </>
    )
}

export default ManagementHistory